import routerOptions0 from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}